// extracted by mini-css-extract-plugin
module.exports = {"productLabel":"productlabel-module__productLabel___1TXzR","invert":"productlabel-module__invert___1GELz"};